export {
  getFirebaseConfig
}


const getFirebaseConfig = () => {
  return gon.firebase_config;
}